// extracted by mini-css-extract-plugin
export default {"your_rd":"mF","title":"nF","subtitle":"oF","rd_bio_wrapper":"pF","rd_text_mobile":"qF","rd_bio":"rF","img":"sF","rd_info":"tF","rd_name":"uF","rd_stat":"vF","rd_text":"wF","btn_mobile":"xF"};
    if(module.hot) {
      // 1730991508005
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  